import router, { constantRoutes, resetRouter } from "./router";
import NProgress from "nprogress";
import "nprogress/nprogress.css"; 
import { message } from "ant-design-vue";
import { getItem } from "@/utils/storage"; 

NProgress.configure({ showSpinner: false }); 

const whiteList = ["/login", "/404", "/house","/mini"]; 

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const hasToken = getItem('token');
  //判断是否有token
  if (hasToken) {
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      //白名单中有的路由，可以继续访问
      next();
    } else {
      message.warning("请先登录");
      //否则，白名单中没有的路由，跳回首页
      next(`/login`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

